import { TESTIMONIALS } from "@/data/content";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <section className="bg-[#F5F5F5]" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="max-w-2xl mb-14">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#2873B8] mb-4">Kundenstimmen</p>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#0C2749]" style={{ fontFamily: "Outfit" }}>
            Vertrauen, das trägt.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white border border-slate-200 hover:border-[#2873B8] transition-colors p-8 md:p-10 group"
            >
              <Quote className="w-8 h-8 text-[#2873B8]/40 mb-4" />
              <p className="text-lg leading-relaxed text-[#0C2749] mb-6" style={{ fontFamily: "Outfit", fontWeight: 500 }}>
                „{t.quote}"
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="font-semibold text-[#0C2749]">{t.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{t.role}</p>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: t.rating }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-[#2C80C8] text-[#2C80C8]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
